import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'app-formly-field-date-time',
  templateUrl: './formly-field-date-time.component.html',
  styleUrls: ['./formly-field-date-time.component.scss']
})
export class FormlyFieldDateTimeComponent extends FieldType
{

}
